import {PlusOutlined} from '@ant-design/icons';
import {Badge, Button, Form} from 'antd';
import React, {FC, memo} from 'react';

import {
    useAutoAddOnEmpty
} from '../../hooks/use-auto-add-on-empty';
import {FinancialSources} from './financial-sources';

interface IFinancialSourcesWrapperProps {
    fields: any[];
    add: () => void;
    remove: (index: number) => void;
}

const FinancialSourcesWrapperInner = memo<IFinancialSourcesWrapperProps>(
    ({fields, add, remove} : IFinancialSourcesWrapperProps) => {

    const {handleAdd} = useAutoAddOnEmpty(fields.length, add);

    return (
        <>
            <Badge count={fields.length} className="add-project-badge">
                <Button
                    type="primary"
                    onClick={handleAdd}
                    icon={<PlusOutlined />}
                    className="add-project-button"
                >
                    Добавить источник финансирования
                </Button>
            </Badge>

            {fields.map((field) => (
                <FinancialSources
                    key={field.key}
                    field={field}
                    onRemove={remove}
                />
            ))}
        </>
    );
});

export const FinancialSourcesWrapper: FC = () => (
        <div className="form-flex">
            <div className="form-flex-row">
                <div
                    className="form-flex"
                    style={{
                        maxHeight: 'calc(min(600px, 64vh))',
                        overflow: 'auto',
                        paddingRight: 8,
                        width: '100%',
                    }}
                >
                    <Form.List name="finSources" >
                        {(fields, {add, remove}) => (
                            <FinancialSourcesWrapperInner
                                fields={fields}
                                add={add}
                                remove={remove}
                            />
                        )}
                    </Form.List>
                </div>
            </div>
        </div>
    );
